import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { GoverningJurisdictionTypeId } from '../../../../models/enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionNamePipe } from '../../../../views/shared/pipes/governing-jurisdiction-name.pipe';

@Component({
  selector: 'app-final-location-line',
  standalone: true,
  imports: [NgIf, GoverningJurisdictionNamePipe],
  templateUrl: './final-location-line.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FinalLocationLineComponent {
  /** The jurisdiction in use; null means Default(s). */
  @Input({ required: true }) finalLocationId!: GoverningJurisdictionTypeId | null;
}
